import http from './axiosConfig' //引入基础配置
// let baseUrl = "http://192.168.0.51:8000"  //张--换地址一定要把store也换上
let baseUrl = "https://www.turbine.fit/qiapi"  //线上ip地址
// let baseUrl = '/qiapi'  //线上域名地址
// let baseUrl = "http://192.168.1.15:8000"  //开发端口
// let baseUrl = "/api"  

// 第一期对接的功能内容
import PhaseI from "./PhaseI";
// 三个大屏中的请求数据
import BigScreen from "./BigScreen";
// 配件库接口功能
import parts from "./parts";
// 工程师功能
import engineer from "./engineer";
// 知识库行业资讯第三次更改
import article from "./article";
//2022年1月19日修改行业资讯知识库
import newEditionNewsKnow from "./newEditionNewsKnow.js";
//录播视频功能
import recordVideo from "./recordVideo.js"
//知识问答
import questionAnswering from "./questionAnswering.js"
//下载中心
import DownloadApi from "./DownloadApi.js"
//客户管理
import customer from "./customer.js"
//我的设备
import myDevice from "./myDevice.js"

//改成代理服务器地址
// let baseUrl = "/api"  //这里基础地址
let getData = {}
//post的数据请求方式
getData.ceChi = (data)=>{
  return http.post(baseUrl,data)
}

getData.baseUrl = baseUrl
getData.baseIMG = baseUrl+'/media'
 
getData.allowrance=baseUrl+'/static/upload/default/企业授权委托书.docx'

// ---------- 二次新增功能-开始
//超级管理员创建公司管理员--李
getData.managercreatestaffv3= (data)=>{ 
  return http.post(baseUrl+"/one/managercreatestaffv3/",data)
}
//超级管理员查看待新建公司的用户--李
getData.getnoneuser = (data)=>{ 
  return http.get(baseUrl+"/one/getnoneuser/",{ params:data })
}
//超级管理员创建公司--李
getData.managercreatecompany= (data)=>{ 
  return http.post(baseUrl+"/one/managercreatecompany/",data)
}
//工单上传word文档--李
getData.uploadtech= (data)=>{ 
  return http.post(baseUrl+"/one/uploadtech/",data)
}
//标签选择--李
getData.useraddtags = (data)=>{ 
  return http.post(baseUrl+"/one/useraddtags/",data)
}
//修改标签--李
getData.useredittags = (data)=>{ 
  return http.post(baseUrl+"/one/useredittags/",data)
}
//查看用户标签--李 user_id
getData.usertags = (data)=>{ 
  return http.get(baseUrl+"/one/usertags/",{ params:data })
}
//知识库，行业资讯点赞接口 --李
getData.thumbsUp= (data)=>{ 
  return http.post(baseUrl+"/one/thumbsknowledge/",data)
}
//知识库，行业资讯收藏接口 --李
getData.collectknowledge= (data)=>{ 
  return http.post(baseUrl+"/one/collectknowledge/",data)
}
//知识库，行业资讯取消收藏接口 --李
getData.uncollectknowledge= (data)=>{ 
  return http.post(baseUrl+"/one/uncollectknowledge/",data)
}
//用户查看收藏夹功能接口 --李
getData.viewcollection= (data)=>{ 
  return http.post(baseUrl+"/one/viewcollection/",data)
}
//后台预览工单解决方案 --李
getData.viewDocx= (data)=>{ 
  return http.get(baseUrl+"/one/viewdoc/",{ params:data })
}
//后台删除工单 --李
getData.deleteTech= (data)=>{ 
  return http.post(baseUrl+"/one/deletetech/",data)
}
//为知识库/行业资讯添加标签
getData.kaddtag= (data)=>{ 
  return http.post(baseUrl+"/one/kaddtag/",data)
}
//知识库列表获取
getData.userknowlegematchbytags= (data)=>{ 
  return http.post(baseUrl+"/one/userknowlegematchbytags/",data)
}
//知识库列表获取
getData.userknowlegematchbytags2= (data)=>{ 
  return http.post(baseUrl+"/one/userknowlegematchbytags2/",data)
}
//技术方案通过审核
getData.activetech= (data)=>{ 
  return http.post(baseUrl+"/one/activetech/",data)
}
//查询知识库  参数：keywords 关键字
getData.selectknoledgev1= (data)=>{ 
  return http.get(baseUrl+"/one/selectknoledgev1/",{ params:data })
}
//查询行业资讯  参数：keywords 关键字
getData.selectknoledgev2= (data)=>{ 
  return http.get(baseUrl+"/one/selectknoledgev2/",{ params:data })
}
//行业资讯查询
getData.viewknowledge1= (data)=>{ 
  return http.get(baseUrl+"/one/viewknowledge1/",{ params:data })
}
//前端控制台-员工管理-编辑功能 --周
getData.changeStaffWork= (data)=>{ 
  return http.post(baseUrl+"/one/managerchangestaffwork/",data)
}
//后端控制台-更新知识库/行业资讯-审核功能 --周
getData.verify= (data)=>{ 
  return http.post(baseUrl+"/one/verify/",data)
}
//上传图片
getData.uploadimage= (data)=>{ 
  return http.post(baseUrl+"/one/uploadimage/",data);
}
//为数据组添加报警规则
getData.addalert= (data)=>{ 
  return http.post(baseUrl+"/one/addalert/",data)
}
//数据组修改报警规则 
getData.editalertPost= (data)=>{ 
  return http.post(baseUrl+"/one/editalert/",data)
}
// 数据组查看报警规则  
getData.editalertGet= (data)=>{ 
  return http.get(baseUrl+"/one/editalert/",{ params:data })
}
//数据组删除报警规则
getData.deletealert= (data)=>{ 
  return http.post(baseUrl+"/one/deletealert/",data)
}
//获取告警记录
getData.alarmloglist= (data)=>{ 
  return http.post(baseUrl+"/one/alarmloglist/",data)
}
//==================2021-02-07下午================
//创建工单时保存为草稿
getData.addworksheetdraft= (data)=>{ 
  return http.post(baseUrl+"/one/addworksheetdraft/",data)
}
// 新增知识库、行业资讯草稿
getData.addknowledgedraft= (data)=>{ 
  return http.post(baseUrl+"/one/addknowledgedraft/",data)
}
//解决报警功能
getData.solvealarm= (data)=>{ 
  return http.get(baseUrl+"/one/solvealarm/",{ params:data })
}
// 查询告警信息接口
getData.searchalarmlog= (data)=>{ 
  return http.get(baseUrl+"/one/searchalarmlog/",{ params:data })
}
//首页联系我们留言功能
getData.leavecontactmessage= (data)=>{ 
  return http.post(baseUrl+"/one/leavecontactmessage/",data)
}
//后台查看所有留言列表
getData.contactmessagelist= (data)=>{ 
  return http.post(baseUrl+"/one/contactmessagelist/",data)
}
//后台查看留言详情
getData.viewcontactmessage= (data)=>{ 
  return http.post(baseUrl+"/one/viewcontactmessage/",data)
}
// 前台我的设备历史数据
getData.yestaday= (data)=>{ 
  return http.get(baseUrl+"/one/yestaday/",{ params:data })
}
// 扫码获取code登录
getData.qrcode= (data)=>{ 
  return http.get(baseUrl+"/one/qrcode/",{ params:data })
}
// 扫码绑定
getData.qrcodev1= (data)=>{ 
  return http.get(baseUrl+"/one/qrcodev1/",{ params:data })
}
// 解除绑定
getData.qrcodev2= (data)=>{ 
  return http.get(baseUrl+"/one/qrcodev2/",{ params:data })
}
//前台用户查询所有已发送的消息
getData.selectallannounce= (data)=>{ 
  return http.post(baseUrl+"/one/selectallannounce/",data)
}
//前台用户查询已发送的消息详情
getData.selectannounce= (data)=>{ 
  return http.post(baseUrl+"/one/selectannounce/",data)
}
//后台修改机械设备设备信息
getData.editdevice= (data)=>{ 
  return http.post(baseUrl+"/one/editdevice/",data)
}

// 历史数据echarts图例点击事件接口  --  李
getData.yesterdaysub= (data)=>{ 
  return http.get(baseUrl+"/one/yesterdaysub/",{ params:data })
}
//最近一个星期图例点击事件
getData.weeksub= (data)=>{ 
  return http.get(baseUrl+"/one/weeksub/",{ params:data })
}
//最近一个月图例点击事件
getData.monthsub= (data)=>{
  return http.get(baseUrl+"/one/monthsub/",{ params:data })
}
//知识库 标签 
getData.knowledgeTags= (data)=>{ 
  return http.get(baseUrl+"/one/choose_knowledge_tip/",{ params:data })
}
//知识库 文章标签相关推荐 
getData.knowledgeItemTags= (data)=>{ 
  return http.get(baseUrl+"/one/choose_knowledge_tip1/",{ params:data })
}
//行业资讯 标签 
getData.newsTags= (data)=>{ 
  return http.get(baseUrl+"/one/choose_message_tip/",{ params:data })
}
//行业资讯 文章标签相关推荐  
getData.newsItemTags= (data)=>{ 
  return http.get(baseUrl+"/one/choose_message_tip1/",{ params:data })
}
//行业资讯 文章标签相关推荐  
getData.aboutRecommend= (data)=>{ 
  return http.get(baseUrl+"/one/about_recommend/",{ params:data })
}

//---------二次新增功能-结束
var newGetData = Object.assign(getData, PhaseI,BigScreen,parts,engineer,article,newEditionNewsKnow,recordVideo,questionAnswering,DownloadApi,customer,myDevice);
export default newGetData
export const newBaseUrl=baseUrl


// WEBPACK FOOTER //
// ./src/common/api.js